import type { StyleSystemProps, CSSObject } from '@withjoy/joykit';
import { styled, Flex, Box, FormControl } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
export const StyledCardWrapper = styled(Flex)``;
const cardWrapperStyles: StyleSystemProps = {
  flexDirection: { _: 'column', sm2: 'column', md: 'column' },
  minHeight: { _: '100%', md: pxToRem(88) },
  width: '100%',
  justifyContent: 'center',
  alignItems: { _: 'flex-start', sm2: 'center', md: 'flex-start' },
  textAlign: 'center',
};

export const StyledRegistryGuideWrapper = styled(Flex)``;
const registryGuideWrapperStyles: StyleSystemProps = {
  marginRight: 4,
};

export const StyledSaveButton = styled(Box)``;
const saveButtonStyles: StyleSystemProps = {
  _hover: { backgroundColor: 'mono12' },
  _active: { backgroundColor: 'mono13' },
  height: pxToRem(40),
  backgroundColor: 'mono14',
  width: '100%',
  color: 'white',
  borderRadius: 2,
  flex: '1 1 50%',
};

export const StyledFormControl = styled(FormControl)``;
const formControlStyles: CSSObject = {
  flex: '1 1 50%',
  input: {
    textAlign: 'center',
    fontSize: 64,
    fontWeight: 400,
    lineHeight: 96,
  },
};

const cancelHoverStyles = {
  color: 'mono5',
  backgroundColor: 'transparent',
};

const cancelActiveStyles = {
  color: 'mono7',
  backgroundColor: 'transparent',
};

export const styles = {
  formControl: formControlStyles,
  saveButton: saveButtonStyles,
  cancelHover: cancelHoverStyles,
  cancelActive: cancelActiveStyles,
  cardWrapper: cardWrapperStyles,
  registryGuideWrapper: registryGuideWrapperStyles,
};
